export default "__VITE_ASSET__Ddg94cFK__"